module.exports = __webpack_public_path__ + "img/19a-doc-publicacoes-nova.e9a25f62.png";